import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { DocumentRequirement } from "../../../../../models/document-requirement";
import { Registration } from "../../../../../models/registration";
import { Requirement } from "../../../../../models/requirement";
import { DocumentRequirementControllerService } from "../../../../../services/requirement-controller/document-requirement-controller.service";
import { RequirementControllerService } from "../../../../../services/requirement-controller/requirement-controller.service";
import { RequirementService } from "../../../../../services/requirement-controller/requirement.service";
import { Store } from "../../../../../services/store.service";
import { TranslatedBaseError } from "../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";
import { ApplicationFileFormsContainer } from "../../../application-file/forms-container";
import { map } from "rxjs/internal/operators/map";

import { RecoverOrphanConfig } from "../../../../../models/recover-orphan-config";

@Component({
  selector: "registration-requirement",
  templateUrl: "./requirement-registration.component.html",
  providers: [DocumentRequirementControllerService, ToastrService],
})
export class RegistrationRequirementComponent extends TranslatedBaseError implements OnChanges, OnInit, OnDestroy {

  @Input() public registration: Registration;
  @Input() public serviceId: string;
  @Input() public smallView: boolean;
  @Input() public disabled: boolean = false;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public debugErrors: RecoverOrphanConfig[] = [];
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public updateFunction = new EventEmitter();
  public documentRequirementList: any[] = [];
  public documentRequirementListLength: number;
  public showModal: boolean;
  public selectedDocRequirement: any;
  public requirements: any[] = [];
  public alternativeRequirements: any[] = [];
  public showDeterminant: boolean[] = [];

  public searchRequirementFilter: any = {
    name: null,
  };

  public documentRequirement: any;
  public requirement: any;
  public addNew: boolean = false;
  public showDeterminantBuilder: boolean = false;
  public showList: boolean = false;
  public isCollapsed: boolean = false;

  public subscription: any;

  constructor(private documentRequirementService: DocumentRequirementControllerService,
    private requirementService: RequirementService,
    private requirementControllerService: RequirementControllerService,
    public store: Store,
    toastr: ToastrService,
    public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit(): void {
    this.subscription = this.requirementService.update.subscribe((data) => {
      if (data.update) {
        this.reloadDocumentRequirementList();
      }
    });

  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.serviceId && changes.serviceId.currentValue) {
      this.serviceId = changes.serviceId.currentValue;
    }
    if (changes.registration && changes.registration.currentValue) {
      this.registration = changes.registration.currentValue;
      this.reloadDocumentRequirementList();
    }
  }

  public dropped(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

      // component logic
      if (!this.disabled) {
        this.documentRequirementList.forEach((it, index, itemsArray) => {
          itemsArray[index].sortOrder = index;
          itemsArray[index].registrationId = this.registration.id;
          itemsArray[index].requirementId = itemsArray[index].requirement.id;
        });
        this.sortDocumentRequirementList();
      }
    }
  }

  public reloadDocumentRequirementList() {
    if (this.registration && this.registration.id) {
      this.documentRequirementService.getRegistrationRequirements(this.registration.id).subscribe(
        (data) => {
          const deletedItems = [];
          for (const existingItem of this.documentRequirementList) {
            const keepThis = data.some((regDocReq) => {
              return regDocReq.id === existingItem.id;
            });
            if (!keepThis) { deletedItems.push(existingItem); }
          }
          deletedItems.forEach((item) => {
            this.documentRequirementList.splice(this.documentRequirementList.indexOf(item), 1);
          });
          for (const regDocReq of data) {
            const existingItem = this.documentRequirementList.find((item) => {
              return item.id === regDocReq.id;
            });
            if (regDocReq.linkingFileUploadPath) {
              regDocReq.linkingFileUploadPathRouterLink =
                this.routerLinkForLinkingFileUploadPath(regDocReq.linkingFileUploadPath);
              regDocReq.linkingFileUploadPathTitle =
                regDocReq.linkingFileUploadPath.substring(regDocReq.linkingFileUploadPath.lastIndexOf("#") + 1);
            }
            if (existingItem) {
              this.documentRequirementList[this.documentRequirementList.indexOf(existingItem)] = regDocReq;
            } else {
              this.documentRequirementList.push(regDocReq);
            }
          }
          this.updateData(this.documentRequirementList);
        },
        (error) => this.showErrorMessage(error),
      );
      this.searchRequirementFilter.name = null;
      console.log(this.searchRequirementFilter);

    }
  }

  public sortDocumentRequirementList() {
    this.documentRequirementService.updateSortOrder(this.registration.id, this.documentRequirementList).subscribe(
      () => this.responseSuccessful("Requirements reordered!"),
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public updateData(data) {
    this.showList = false;
    this.showDeterminant = new Array(data.length).fill(false);
    this.loadServiceRequirements(data);
  }

  public loadServiceRequirements(documentRequirementList: any) {
    this.requirementControllerService.getServiceRequirements().subscribe(
      (data) => {
        this.removeRequirementsOverlappingWithDocumentRequirementsOrDocumentResults(
          documentRequirementList,
          data);
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public removeRequirementsOverlappingWithDocumentRequirementsOrDocumentResults(documentRequirementsOrDocumentResults: any[], requirements: Requirement[]) {
    for (let j = documentRequirementsOrDocumentResults.length - 1; j >= 0; j--) {
      for (let i = requirements.length - 1; i >= 0; i--) {
        if (requirements[i].id === documentRequirementsOrDocumentResults[j].requirement.id) {
          requirements.splice(i, 1);
        }
      }
    }
    this.requirements = requirements.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
    });
    this.documentRequirementList = documentRequirementsOrDocumentResults;
    this.documentRequirementListLength = documentRequirementsOrDocumentResults.length;
  }

  public openEdit(requirement: any, determinantView = false, name?: string) {
    if (!this.disabled) {
      this.showList = false;
      this.showDeterminantBuilder = determinantView;
      if (requirement) {
        this.documentRequirement = requirement;
        this.requirement = this.documentRequirement.requirement;
        this.addNew = false;
      } else {
        this.documentRequirement = new DocumentRequirement();
        this.requirement = new Requirement();
        console.log(this.searchRequirementFilter);
        if (name) {
          this.requirement.name = name;
        } else if (this.searchRequirementFilter.name !== null) {
          this.requirement.name = this.searchRequirementFilter.name;
        }
        this.documentRequirement.determinants = [];
        this.documentRequirement.alternative = false;
        this.documentRequirement.requirement = this.requirement;
        this.addNew = true;
      }
      this.updateEditData();
    }
  }

  public determinantAllowed(item): boolean {
    return !item.linkingFileUploadPath;
  }

  public hasDeterminant(item) {
    if (!item.jsonDeterminants || item.jsonDeterminants === '[{"type":"OR","items":[]}]') {
      return false;
    }
    return true;
  }

  public hasError(id: string): boolean {
    return this.debugErrors && this.debugErrors.some((error) => error.objectId === id);
  }

  public removeDeterminant(requirement, index) {
    if (!this.disabled) {
      requirement.registrationId = this.registration.id;
      requirement.jsonDeterminants = "";
      this.documentRequirementService.saveRegistrationRequirement(requirement).subscribe(
        () => {
          this.showDeterminant[index] = false;
          this.responseSuccessful("Result updated");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public fixVisualEffectOnDocumentRequirementSelected(requirement): void {
    this.showList = false;
    const documentRequirement = new DocumentRequirement();
    documentRequirement.determinants = [];
    documentRequirement.alternative = false;
    documentRequirement.requirement = requirement;
    documentRequirement.registrationId = this.registration.id;
    documentRequirement.requirementId = requirement.id;
    this.documentRequirementList.push(documentRequirement);
  }

  public addDocumentRequirement(requirement) {
    if (!this.disabled) {
      const documentRequirement = new DocumentRequirement();
      documentRequirement.determinants = [];
      documentRequirement.alternative = false;
      documentRequirement.requirement = requirement;
      documentRequirement.registrationId = this.registration.id;
      documentRequirement.requirementId = requirement.id;

      // for visual effect
      this.fixVisualEffectOnDocumentRequirementSelected(requirement);

      this.documentRequirementService.addRegistrationRequirement(this.registration.id, documentRequirement).subscribe(
        () => {
          this.reloadDocumentRequirementList();
          this.responseSuccessful("Requirement is added to registration");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public deleteDocumentRequirement(isConfirmed: boolean, documentRequirementId) {
    if (!this.disabled && isConfirmed) {
      this.documentRequirementService.deleteRegistrationRequirement(documentRequirementId).subscribe(
        () => this.reloadDocumentRequirementList(),
      );
    }
  }

  public saveDocumentRequirement(req: DocumentRequirement) {
    if (!this.disabled && this.registration) {
      req.registrationId = this.registration.id;
      this.documentRequirementService.saveRegistrationRequirement(req).subscribe(
        () => this.responseSuccessful("Determinant group saved successfully!"),
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public showOrAdd() {
    if (!this.disabled) {
      if (this.requirements.length > 0) {
        this.showList = !this.showList;
      } else {
        this.openEdit(false);
      }
    }
  }

  public updateEditData() {
    if (!this.disabled) {
      this.store.state.common.sections.type = "requirement";
      this.requirementService.serviceId = this.serviceId;
      this.requirementService.registration = this.registration;
      this.requirementService.documentRequirement = JSON.parse(JSON.stringify(this.documentRequirement)); // mini-hack so the list doesn't update when working in edit layer;
      this.requirementService.requirement = JSON.parse(JSON.stringify(this.requirement)); // mini-hack so the list doesn't update when working in edit layer;
      this.requirementService.addNew = this.addNew;
      this.requirementService.showDeterminantBuilder = this.showDeterminantBuilder;
      this.requirementService.initEdit();
    }
  }

  /*public searchRequirementChanged(value: any): void {
    this.searchRequirementFilter = value;
  }*/

  public routerLinkForLinkingFileUploadPath(value: string): string {
    if (!value) { return ""; }
    return ApplicationFileFormsContainer.formPaths.includes(value.split("#")[1])
      ? "/services/" + value.replace("#", "/forms/")
      : "/services/" + value.replace("#", "/roles/");
  }

  public addDocumentRequirements(items: any[]): void {
    const promises = [];
    items.forEach(item => {
      this.fixVisualEffectOnDocumentRequirementSelected(item);
      const documentRequirement = new DocumentRequirement();
      documentRequirement.determinants = [];
      documentRequirement.alternative = false;
      documentRequirement.requirement = item;
      documentRequirement.registrationId = this.registration.id;
      documentRequirement.requirementId = item.id;
      promises.push(
        this.documentRequirementService.addRegistrationRequirement(this.registration.id, documentRequirement).pipe(map((data) => data)).toPromise()
      );
    });
    Promise.all<any[]>(promises).then((results: any[]) => {
      this.responseSuccessful("Requirement added!");
      this.showList = false;
      this.reloadDocumentRequirementList();
    });
  }

}
